<template>
  <div>
    <div class="img-color-overlay">
      <div class="container">
        <div class="row section-separator">
          <div class="col-sm-12 col-md-6">
            <div class="mh-education">
                <h3 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                    {{ $t('experiences.education') }}
                </h3>
              <div class="mh-education-deatils">
                <!-- Education Institutes-->
                <div class="mh-education-item dark-bg wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.3s; animation-name: none;">
                    <h4 class="mh-eduyear mb-3"><a target="_blank" href="https://www.nwpu.edu.cn">{{ $t('experiences.northwesternPolytechnicalUniversity') }}</a></h4>
                    <!-- <div class="mh-eduyear">{{ $t('experiences.educationPeriod') }}</div> -->
                    <span>{{ $t('experiences.major') }}：</span>
                    <ul class="pl-0">
                        <li><v-icon size="12" class="mr-2">fa fa-circle</v-icon>{{ $t('experiences.computerScienceAndTechnology') }}</li>
                        <li><v-icon size="12" class="mr-2"></v-icon></li>
                        <li><v-icon size="12" class="mr-2"></v-icon></li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="mh-work">
              <h3>{{ $t('experiences.workExperience') }}</h3>
              <div class="mh-experience-deatils">

                <!-- Education Institutes-->
                <div class="mh-work-item dark-bg wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: none;">
					<!-- <v-timeline dense>
                        <v-timeline-item v-for="(experience, i) in experiences" :key="i" color="primary-bg" small>
                            <h4>
                                <a target="_blank" :href="experience.url">{{ experience.company }}</a>
                            </h4>
                            <div>{{ experience.year }}</div>
                        </v-timeline-item>
                    </v-timeline> -->
                    
                    <!-- <h4 class="mh-eduyear mb-3"><a target="_blank" href="http://qiandian.tech">untrading.org</a></h4>
                    <div>{{ $t('experiences.workPeriod') }}</div>

					<h4 class="mh-eduyear mb-3"><a target="_blank" href="http://qiandian.tech">iob.fi DAO</a></h4>
                    <div>{{ $t('experiences.workPeriod') }}</div>

					<h4 class="mh-eduyear mb-3"><a target="_blank" href="http://qiandian.tech">IOB llc</a></h4>
                    <div>{{ $t('experiences.workPeriod') }}</div>

					<h4 class="mh-eduyear mb-3"><a target="_blank" href="http://qiandian.tech">{{ $t('experiences.shanghaiQiandianInformationTechnologyCoLtd') }}</a></h4>
                    <div>{{ $t('experiences.workPeriod') }}</div> -->

                    <h4 class="mh-eduyear mb-3">
                        <a target="_blank" href="https://www.linkedin.com/in/louisliuoneself/">untrading.org</a>
                    </h4>
                    <div>{{ $t('experiences.workPeriod') }}</div>

                    <div class="row mt-5">
						<div class="col-sm-12 col-md-6">
							<span>{{ $t('experiences.position') }}：</span>
							<ul class="pl-0">
								<li><v-icon size="12" class="mr-2">fa fa-circle</v-icon>{{ $t('experiences.fullStackDeveloper') }}</li>
							</ul>
						</div>
						<div class="col-sm-12 col-md-6">
							<span>{{ $t('experiences.duty') }}：</span>
							<ul class="pl-0">
								<li><v-icon size="12" class="mr-2">fa fa-circle</v-icon>{{ $t('experiences.duty1') }}</li>
								<li><v-icon size="12" class="mr-2">fa fa-circle</v-icon>{{ $t('experiences.duty2') }}</li>
								<li><v-icon size="12" class="mr-2">fa fa-circle</v-icon>{{ $t('experiences.duty3') }}</li>
								<li><v-icon size="12" class="mr-2">fa fa-circle</v-icon>{{ $t('experiences.duty4') }}</li>
								<li><v-icon size="12" class="mr-2">fa fa-circle</v-icon>{{ $t('experiences.duty5') }}</li>
							</ul>
						</div>
					</div>
                </div>
                <div class="mh-work-item dark-bg wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: none;">
                    <h4 class="mh-eduyear mb-3">
                        <a target="_blank" href="http://qiandian.tech">{{ $t('experiences.shanghaiQiandianInformationTechnologyCoLtd') }}</a>
                    </h4>
                    <div>{{ $t('experiences.workPeriod') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
      return {
        experiences: [
            {
                company: 'untrading.org',
                year: '2018年 - 至今',
                url: 'http://qiandian.tech',
            },
            {
                company: 'iob.fi DAO',
                year: '2018年 - 至今',
                url: 'http://qiandian.tech',
            },
            {
                company: 'IOB llc',
                year: '2018年 - 至今',
                url: 'http://qiandian.tech',
            },
            {
                company: '上海乾点信息科技有限公司',
                year: '2018年 - 至今',
                url: 'http://qiandian.tech',
            },
        ],
      }
    },
    components: {},
    created() {

    },
    mounted() {

    },
    computed: {

    },
    watch: {

    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Experience.vue